import Actions from '../OnboardingForm/DocumentsUpload/Actions';

export default [
	// { title: 'File', field: 'actions', component: Actions },
	{ title: 'Document', field: 'file_name' },
	{ title: 'Uploaded By', field: 'created_by_name' },
	{ title: 'Date', field: 'created_at' },
	{ title: 'Actions', field: 'actions', component: Actions },
];
